import type { IxcTradereportingV1CatReportKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const CAT_REPORT_BASE_PATH = getResolvedPath('/clearing/compliance/reporting/cat');

export const getCatReportPath: EntityPathBuilder<IxcTradereportingV1CatReportKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return CAT_REPORT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.reportId) {
        return undefined;
      }

      return getResolvedPath(`${CAT_REPORT_BASE_PATH}/$reportId`, context.keys);
    }
  }
};

export function getCatReportDetailPath(reportId: string | undefined) {
  if (!reportId) {
    return undefined;
  }

  return getCatReportPath({ kind: 'detail', keys: { reportId } });
}
